// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'folder';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M17.438 5.063a1.125 1.125 0 0 0-1.125-1.125H7.874l-1.35-1.8a1.125 1.125 0 0 0-.9-.45H1.687A1.125 1.125 0 0 0 .563 2.813v12.374a1.125 1.125 0 0 0 1.125 1.126h14.626a1.125 1.125 0 0 0 1.125-1.125z'
  />
);

export const viewBox = '0 0 18 18';
